import React from "react";
import TooltipSVG from "@/assets/icons-js/tooltip";

type TTooltipProps = {
    children: React.ReactNode,
    className?: string,
}

const Tooltip = ({ children, className }: TTooltipProps) => {
    return (
        <div className={ ["tooltip", className ?? ""].join(" ") }>
            <TooltipSVG/>
            <div>
                { children }
            </div>
        </div>
    );
};

export default Tooltip;
